import { Box, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'

type VariantType =
  | 'button'
  | 'caption'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'inherit'
  | 'paragraph'
  | 'subtitle1'

interface YearlySectionHeaderProps {
  title: string
  variant: VariantType
  daysMode: boolean[]
  setDaysMode: (value: boolean[]) => void
  index: number
}

export const YearlySectionHeader = (props: YearlySectionHeaderProps) => {
  const { t } = useTranslation()

  const handleTimeFormatChange = (_event: React.MouseEvent<HTMLElement>, newAlignment: 'days' | 'hours' | null) => {
    if (newAlignment !== null) {
      const newDaysMode = [...props.daysMode]
      newDaysMode[props.index] = newAlignment === 'days'
      props.setDaysMode(newDaysMode)
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        maxHeight: '10%',
        marginBottom: 1,
      }}
    >
      <Typography variant={props.variant} sx={{ color: 'text.light', fontWeight: 'bold', fontSize: '1.25rem' }}>
        {props.title}
      </Typography>

      <ToggleButtonGroup
        exclusive
        value={props.daysMode[props.index] ? 'days' : 'hours'}
        onChange={handleTimeFormatChange}
        sx={{ fontSize: '0.8rem', height: '30px', width: '74px' }}
      >
        <ToggleButton value={'days'} aria-label="dense layout">
          <Tooltip title={t('components.tooltip.daysLayout')}>
            <CalendarTodayIcon sx={{ width: 14, color: 'text.highEmphasis' }} />
          </Tooltip>
        </ToggleButton>
        <ToggleButton value={'hours'} aria-label="scattered layout">
          <Tooltip title={t('components.tooltip.hoursLayout')}>
            <AccessTimeIcon sx={{ width: 14, color: 'text.highEmphasis' }} />
          </Tooltip>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}
